/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  // Injectable,
  // LOCALE_ID,
  NgModule,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from "@azure/msal-angular";
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
  createNestablePublicClientApplication,
} from "@azure/msal-browser";
import {
  NB_TIME_PICKER_CONFIG,
  NbChatModule,
  NbDatepickerModule,
  //NbDateService,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { environment } from "../environments/environment";
import { AuthService } from "./@core/auth/auth.service";
import { CoreModule } from "./@core/core.module";
import { InjectorResolver } from "./@core/injector/injector.service";
import { sessionProviderFactory } from "./@core/session/session.module";
import { SessionService } from "./@core/session/session.service";
import { ThemeModule } from "./@theme/theme.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PagesModule } from "./pages/pages.module";
import { PopupBlockedDialogModule } from "./shared/dialogs/popup-blocked-dialog/popup-blocked-dialog.module";
import { AuthInterceptor } from "./@core/interceptors/auth.interceptor";
import { AuthGuard } from "./@core/auth/authGuard";
import { NgxEchartsModule } from "ngx-echarts";
import * as echarts from "echarts";
import { isRunningInTeams } from "./@core/utils/teams-utils";
import { TuiRootModule } from "@taiga-ui/core";

export function loggerCallback(logLevel: LogLevel, message: string) {}

const isInTeams = window.parent !== window.self;
export function MSALInstanceFactory(): IPublicClientApplication {
  // Detect if running in Teams

  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: environment.msalConfig.auth.redirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      allowNativeBroker: true, // Enable NAA support for Teams
      allowRedirectInIframe: isInTeams, // Allow iframe redirects in Teams
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(
    environment.apiConfig.uri,
    environment.apiConfig.scopes,
  );

  return {
    interactionType: isInTeams
      ? InteractionType.Redirect
      : InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: isInTeams
      ? InteractionType.Redirect
      : InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.apiConfig.scopes],
    },
    // loginFailedRoute: "/login",
  };
}
export function initializeMsal(msalService: MsalService): () => Promise<void> {
  return () => msalService.instance.initialize();
}

// @Injectable()
// export class CustomMomentDateService extends NbMomentDateService {
//   getFirstDayOfWeek(): number {
//     return 1; // Monday
//   }
// }

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    TuiRootModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY",
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    PagesModule,
    MsalModule,
    NgxEchartsModule.forRoot({ echarts }),
    PopupBlockedDialogModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  providers: [
    //    { provide: NbDateService, useClass: CustomMomentDateService },
    //  { provide: LOCALE_ID, useValue: 'en-GB' }, // 'en-GB' starts week on Monday
    SessionService,
    {
      provide: APP_INITIALIZER,
      useFactory: sessionProviderFactory,
      deps: [InjectorResolver, SessionService],
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      provide: NB_TIME_PICKER_CONFIG,
      useValue: {},
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      deps: [MsalService],
      multi: true,
    },
    MsalService,
    MsalGuard,
    AuthGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {}
